export enum FileTypes {
  Images = '.jpg, .png, .jpeg',
  Videos = '.mp4, .webm, .wmv',
  Audio = '.mp3, .wav'
}
